/**
 * Development settings storage.
 */

// Key for development settings
const DEV_SETTINGS_KEY = 'dev_settings';

export interface DevSettings {
  developmentMode: boolean;
  apiKeyLimit: number | 'unlimited';
}

const DEFAULT_DEV_SETTINGS: DevSettings = {
  developmentMode: false,
  apiKeyLimit: 50
};

/**
 * Save development settings
 */
export const saveDevSettings = (settings: DevSettings): boolean => {
  try {
    localStorage.setItem(DEV_SETTINGS_KEY, JSON.stringify(settings));
    return true;
  } catch (error) {
    console.error('Failed to save dev settings:', error);
    return false;
  }
};

/**
 * Get development settings
 */
export const getDevSettings = (): DevSettings => {
  try {
    const stored = localStorage.getItem(DEV_SETTINGS_KEY);
    if (!stored) return DEFAULT_DEV_SETTINGS;

    const settings = JSON.parse(stored);
    return {
      developmentMode: settings.developmentMode ?? DEFAULT_DEV_SETTINGS.developmentMode,
      apiKeyLimit: settings.apiKeyLimit ?? DEFAULT_DEV_SETTINGS.apiKeyLimit
    };
  } catch (error) {
    console.error('Failed to get dev settings:', error);
    return DEFAULT_DEV_SETTINGS;
  }
};

/**
 * Reset development settings
 */
export const resetDevSettings = (): boolean => {
  try {
    localStorage.removeItem(DEV_SETTINGS_KEY);
    return true;
  } catch (error) {
    console.error('Failed to reset dev settings:', error);
    return false;
  }
};
